import { FunctionComponent, useContext } from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import * as s from './Body.css';
import * as T from './Body.types';
import { AddPetContext } from '../AddPet';
import ZeroStep from './ZeroStep';
import FirstStep from './FirstStep';
import SecondStep from './SecondStep';
import ThirdStep from './ThirdStep';
import FourthStep from './FourthStep';
import DeleteAppStep from './DeleteAppStep';
import ErrorMessage from './ErrorMessage';
const Body: FunctionComponent<T.BodyTypes> = ({ step }) => {
    const addPetContext = useContext(AddPetContext);
    const { viewType, isError, isEdit, errorMessage } = addPetContext || {};
    const year2022step = viewType === 'year2022' ? [<ZeroStep key="0"/>] : [];
    const STEPS = {
        isCreate: [
            ...year2022step,
            ...[
                <FirstStep key="1"/>,
                <SecondStep key="2"/>,
                <ThirdStep key="3"/>,
                <FourthStep key="4"/>,
            ],
        ],
        isEdit: [<SecondStep key="2"/>, <DeleteAppStep key="3"/>],
    };
    const currentStep = STEPS[isEdit ? 'isEdit' : 'isCreate'][step];
    return (<div>
      <div className={s.stepsWrapper}>
        <SwitchTransition>
          <CSSTransition key={step} addEndListener={(node, done): void => node.addEventListener('transitionend', done, false)} classNames="fade">
            {isError ? (<ErrorMessage message={errorMessage || ''}/>) : (currentStep)}
          </CSSTransition>
        </SwitchTransition>
      </div>
    </div>);
};
export default Body;
